import {FC, useState} from "react";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import {faSave} from "@fortawesome/free-solid-svg-icons";
import {Input} from "@traas/lib/src/components/form/Input";
import {useApi} from "../api/APIContext";
import {Employee} from "@traas/lib/src/api/dto/Employee";

export const AddRoosterOverrideModal: FC<{employee: Employee, onFinish?: () => void}> = (props) => {
  const {addEmployeeWorkDaysOverride} = useApi()
  const [fromDate, setFromDate] = useState<Date>(new Date());
  const [toDate, setToDate] = useState<Date>(new Date());
  const [error, setError] = useState<string|null>();
  const confirm = async () => {
    await addEmployeeWorkDaysOverride(props.employee, fromDate, toDate)
    props.onFinish?.()
  }

  return <div>
    <div className={'grid grid-cols-2 gap-4'}>
      <Input type={'date'} label={'Van'} value={fromDate} onChange={(x) => {
          if (x >= toDate) {
            setError('Van datum moet vóór de tot datum liggen!')
            return
          }

          setFromDate(x)
          setError(null)
        }}
      />
      <Input type={'date'} label={'Tot'} value={toDate} onChange={(x) => {
          if (x <= fromDate) {
            setError('Tot datum moet later zijn dan van datum!')
            return
          }

          if (x <= new Date()) {
            setError('Tot tijd moet in de toekomst liggen!')
            return
          }

          setToDate(x)
          setError(null)
        }}
      />
    </div>
    {error !== null && <span className={"my-2 text-red-500"}>{error}</span>}
    <ModalFooter text={'Opslaan'} icon={faSave} onSubmit={confirm} disabled={error != null || fromDate === toDate} />
  </div>
}